import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import "./../components/slds-combobox.js";
import { connect } from 'pwa-helpers/connect-mixin.js';
import store from '../src/store';
import { statusArray, locationArray } from '../src/apiCommon';
import { updateSettings, uploadProfilePicture } from '../src/apiActions';
import { setUser, resetStateField, addNotification } from '../src/store';
import { SldsBaseElement } from '../components/slds-base-element.js';

@customElement('settings-view')
class SettingsView extends connect(store)(SldsBaseElement) {
  @property({type: String}) selectedTab = "slds-vertical-tabs-0";

  @property({type: Object}) user = null;

  @property({type: Array}) onOffOptions = [
    {title: "On", id: "on"},
    {title: "Off", id: "off"}
  ];

  @property({type: Object}) selectedFollowThreadOnReply = {title: "On", id: "on"};

  @property({type: Object}) selectedDefaultSelectedOff = {title: "Off", id: "off"};

  @property({type: Object}) selectedDefaultSelectedOn = {title: "On", id: "on"};

  @property({type: Array}) statusOptions = statusArray;

  @property({type: Object}) selectedStatus = {title: "None", id: ""};

  @property({type: Array}) genderOptions = [
    {title: "Male", id: "male"},
    {title: "Female", id: "female"},
    {title: "Unspecified", id: "unspecified"}
  ];
  @property({type: Object}) selectedGender = {title: "Unspecified", id: "unspecified"};

  @property({type: Array}) homeCountryOptions = locationArray;

  @property({type: Object}) selectedHomeCountry = {title: "Select Location...", id: ""};

  @property({type: Boolean}) requestPending = false;

  @property({type: Object}) pendingChanges = {};

  @property({type: Boolean}) hasNewData = false;

  @property({type: Number}) settingsUpdated = null;

  @property({type: Boolean}) facebookConnected = false;

  @property({type: Boolean}) googleConnected = false;

  @property({type: Boolean}) appleConnected = false;

  @property({type: String}) selectedBirthday = "";

  @property({type: String}) about = "";

  @property({type: Object}) adultContent = {title: "Off", id: "off"};

  @property({type: Object}) safeBrowsing = {title: "On", id: "on"};

  @property({type: Object}) hideOffensiveComments = {title: "On", id: "on"};

  @property({type: Object}) hideProfile = {title: "Off", id: "off"};

  @property({type: Object}) interestBasedAdvertising = {title: "Off", id: "off"};

  reset() {
    this.selectedTab = "slds-vertical-tabs-0";
  }

  stateChanged(state) {
    if (state.user) {
      this.user = state.user;
      if (this.user.extra && this.user.extra.followThreadOnReply) {
        this.selectedFollowThreadOnReply = this.user.extra.followThreadOnReply === 'on' ? this.selectedDefaultSelectedOn : this.selectedDefaultSelectedOff;
      }
      if (this.user.homeCountry) {
        this.selectedHomeCountry = this.homeCountryOptions.find((option) => option.id === this.user.homeCountry);
      }
      if (this.user.status) {
        this.selectedStatus = this.statusOptions.find((option) => option.id === this.user.status);
      }
      if (this.user.gender) {
        this.selectedGender = this.genderOptions.find((option) => option.id === this.user.gender);
      }
      if (this.user.birthday) {
        this.selectedBirthday = this.user.birthday;
      }
      if (this.user.about) {
        this.about = this.user.about;
      }
      if (typeof this.user.adultContent === 'boolean') {
        this.adultContent = this.user.adultContent ? this.selectedDefaultSelectedOn : this.selectedDefaultSelectedOff;
      }
      if (typeof this.user.safeBrowsing === 'boolean') {
        this.safeBrowsing = this.user.safeBrowsing ? this.selectedDefaultSelectedOn : this.selectedDefaultSelectedOff;
      }
      if (typeof this.user.hideOffensiveComments === 'boolean') {
        this.hideOffensiveComments = this.user.hideOffensiveComments ? this.selectedDefaultSelectedOn : this.selectedDefaultSelectedOff;
      }
      if (typeof this.user.hideProfile === 'boolean') {
        this.hideProfile = this.user.hideProfile ? this.selectedDefaultSelectedOn : this.selectedDefaultSelectedOff;
      }
      if (typeof this.user.internetAds === 'boolean') {
        this.interestBasedAdvertising = this.user.internetAds ? this.selectedDefaultSelectedOn : this.selectedDefaultSelectedOff;
      }
      this.requestPending = false;
      this.requestUpdate();
    }
    if (state.settingsUpdated !== this.settingsUpdated) {
      this.pendingChanges = {};
      this.hasNewData = false;
      this.settingsUpdated = state.settingsUpdated;
      console.log("settingsUpdated");
      store.dispatch(addNotification(
        {
          type: 'success',
          content: {
            heading: 'Settings updated'
          }
        }
      ));
      this.requestUpdate();
    }
    if (state.settingsUpdateError) {
      const settingsUpdateError = state.settingsUpdateError;
      store.dispatch(resetStateField('settingsUpdateError'));
      if (settingsUpdateError.status === 'username_change_too_recent') {
        this.shadowRoot.getElementById("username").value = this.user.username;
        delete this.pendingChanges.username;
        this.hasNewData = false;
        store.dispatch(addNotification({
					type: 'error',
					content: {
						heading: 'Username changed too recently, please wait 24 hours before changing it again'
					}
        }));
      }
      else {
        store.dispatch(addNotification({
          type: 'error',
          content: {
            heading: (settingsUpdateError.error) ? settingsUpdateError.error : 'Error updating settings'
          }
        }));
      }
    }
  }

  constructor() {
    super();
    const currentPath = window.location.pathname.split("/").pop();
    if (currentPath==="password")
    {
      this.selectedTab = "slds-vertical-tabs-1";
    }
    else if (currentPath==="profile")
    {
      this.selectedTab = "slds-vertical-tabs-2";
    }
    else if (currentPath==="content")
    {
      this.selectedTab = "slds-vertical-tabs-3";
    }
    else if (currentPath==="privacy&safety")
    {
      this.selectedTab = "slds-vertical-tabs-4";
    }
  }

  handleProfilePictureChange(e) {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    store.dispatch(uploadProfilePicture(formData));
  }

  getTabLiClass(sel, target) {
    if (sel === target) {
      return "slds-vertical-tabs__nav-item slds-is-active";
    }
    else
    {
      return "slds-vertical-tabs__nav-item";
    }
  }

  getTabClass(sel, target) {
    if (sel === target) {
      return "slds-vertical-tabs__content slds-show";
    }
    else
    {
      return "slds-vertical-tabs__content slds-hide";
    }
  }

  clickLink(e) {
    e.preventDefault();
    var target = e.target;
    var i = 0;
    while((!target.getAttribute("aria-controls") && !target.getAttribute("aria-controls")) && i<5) {
      target = target.parentElement;
      i++;
    }
    const ariaControls = target.getAttribute("aria-controls");
    const href = target.getAttribute("href");
    this.selectedTab = ariaControls;
    history.pushState({}, null, href);
  }

  saveChanges(e) {
    e.preventDefault();
    this.requestPending = true;
    switch (this.selectedTab) {
      case "slds-vertical-tabs-0":
        var pendingChanges = this.pendingChanges;
        var updateObj = {};
        if (pendingChanges.username) {
          updateObj.username = pendingChanges.username;
        }
        if (pendingChanges.email) {
          updateObj.email = pendingChanges.email;
        }
        if (pendingChanges.followThreadOnReply) {
          updateObj.followThreadOnReply = pendingChanges.followThreadOnReply;
        }
        store.dispatch(updateSettings(updateObj));
        break;
      case "slds-vertical-tabs-1":
        debugger;
        break;
      case "slds-vertical-tabs-2":
        var pendingChanges = this.pendingChanges;
        var updateObj = {};
        if (pendingChanges.profile_pic) {
          updateObj.profile_pic = pendingChanges.profile_pic;
        }
        if (pendingChanges.display_name) {
          updateObj.display_name = pendingChanges.display_name;
        }
        if (pendingChanges.status) {
          updateObj.status = pendingChanges.status;
        }
        if (pendingChanges.gender) {
          updateObj.gender = pendingChanges.gender;
        }
        if (pendingChanges.homeCountry || this.user.homeCountry) {
          updateObj.homeCountry = pendingChanges.homeCountry;
        }
        if (pendingChanges.about) {
          updateObj.about = pendingChanges.about;
        }
        if (pendingChanges.birthday) {
          updateObj.birthday = pendingChanges.birthday;
        }
        store.dispatch(updateSettings(updateObj));
        break;
      case "slds-vertical-tabs-3":
        var pendingChanges = this.pendingChanges;
        var updateObj = {};
        if (pendingChanges.adultContent) {
          updateObj.adultContent = pendingChanges.adultContent;
        }
        if (pendingChanges.safeBrowsing) {
          updateObj.safeBrowsing = pendingChanges.safeBrowsing;
        }
        if (pendingChanges.hideOffensiveComments) {
          updateObj.hideOffensiveComments = pendingChanges.hideOffensiveComments;
        }
        store.dispatch(updateSettings(updateObj));
        break;
      case "slds-vertical-tabs-4":
        var pendingChanges = this.pendingChanges;
        var updateObj = {};
        if (pendingChanges.hideProfile) {
          updateObj.hideProfile = pendingChanges.hideProfile;
        }
        if (pendingChanges.interestBasedAdvertising) {
          updateObj.interestBasedAdvertising = pendingChanges.interestBasedAdvertising;
        }
        store.dispatch(updateSettings(updateObj));
        break;
    }
  }

  randomizeProfilePicture() {
    var profile_pic = `${window.cdnUrl}avatars/${Math.floor(Math.random() * 10979)}.webp`;
    this.shadowRoot.getElementById("profile-picture-url").value = profile_pic;
    this.pendingChanges['profile_pic'] = profile_pic;
    const user = { ...this.user, profile_pic: profile_pic };
    store.dispatch(setUser(user));
    this.requestUpdate();
  }

  handleValueChange(e) {
    this.pendingChanges[e.target.id] = (e.detail) ? e.detail.value.id : e.target.value;
    switch(e.target.id) {
      case 'birthday':
        this.selectedBirthday = e.detail.value;
        if (e.target.value == "") {
          delete this.pendingChanges.birthday;
        }
        break;
      case 'gender':
        this.selectedGender = e.detail.value;
        if (this.selectedGender?.id == "unspecified" && !this.user.gender) {
          delete this.pendingChanges.gender;
        }
        break;
      case 'homeCountry':
        this.selectedHomeCountry = e.detail.value;
        if (this.selectedHomeCountry?.id == "" && !this.user.homeCountry) {
          delete this.pendingChanges.homeCountry;
        }
        break;
      case 'status':
        this.selectedStatus = e.detail.value;
        if (this.selectedStatus?.id == "none" && !this.user.status) {
          delete this.pendingChanges.status;
        }
        break;
      case 'followThreadOnReply':
        if (this.selectedFollowThreadOnReply.id == this.pendingChanges[e.target.id]) {
          delete this.pendingChanges.followThreadOnReply;
        }
        this.selectedFollowThreadOnReply = e.detail.value;
        break;
      case 'username':
        if (this.user.username == e.target.value) {
          delete this.pendingChanges.username;
        }
        break;
      case 'email':
        if (this.user.email == e.target.value) {
          delete this.pendingChanges.email;
        }
        break;
      case 'status':
        if (this.user.status == e.detail.value.id) {
          delete this.pendingChanges.status;
        }
        break;
      case 'about':
        if (this.user.about == e.target.value) {
          delete this.pendingChanges.about;
        }
        break;
      case 'adultContent':
        this.adultContent = e.detail.value;
        if (this.user.adultContent == e.detail.value.id) {
          delete this.pendingChanges.adultContent;
        }
        break;
      case 'safeBrowsing':
        this.safeBrowsing = e.detail.value;
        if (this.user.safeBrowsing == e.detail.value.id) {
          delete this.pendingChanges.safeBrowsing;
        }
        break;
      case 'hideOffensiveComments':
        this.hideOffensiveComments = e.detail.value;
        if (this.user.hideOffensiveComments == e.detail.value.id) {
          delete this.pendingChanges.hideOffensiveComments;
        }
        break;
      case 'hideProfile':
        this.hideProfile = e.detail.value;
        if (this.user.hideProfile == e.detail.value.id) {
          delete this.pendingChanges.hideProfile;
        }
        break;
      case 'interestBasedAdvertising':
        this.interestBasedAdvertising = e.detail.value;
        if (this.user.interestBasedAdvertising == e.detail.value.id) {
          delete this.pendingChanges.interestBasedAdvertising;
        }
        break;
    }
    if (Object.keys(this.pendingChanges).length > 0) {
      this.hasNewData = true;
    }
    else {
      this.hasNewData = false;
    }
  }

  static styles = [
    super.styles,
    css`
    :host {
      margin-bottom: 1.5rem;
      --slds-c-input-color-background: var(--background-color);
      --slds-c-input-color-border: var(--border-color);
      --slds-c-card-color-background: var(--replies-background);
    }
    .slds-vertical-tabs__content, .slds-vertical-tabs__nav-item.slds-is-active {
      background-color: var(--background-color, #fff);
    }
    .slds-vertical-tabs {
      border: 1px solid var(--border-color, #e5e5e5);
    }
    .slds-vertical-tabs__nav {
      background-color: var(--input-text-color, #f3f3f3);
      border-right: 1px solid var(--border-color, #e5e5e5);
    }
    .slds-vertical-tabs__nav-item {
      border-bottom: 1px solid var(--border-color, #e5e5e5);
    }
    .slds-icon {
      --slds-c-icon-color-foreground: var(--text-color, #444);
    }
    .slds-form-element__label {
      color: var(--text-color, #444);
    }
    .slds-vertical-tabs__link {
      color: var(--text-color, #444);
    }
    .slds-vertical-tabs__link:hover svg, a:active svg {
      --slds-c-icon-color-foreground: #0174d3;
    }
    a:focus, a:hover, a:active {
      color: #0174d3 !important;
    }
    .slds-button--neutral, .slds-button_neutral {
      --slds-c-button-color-background: var(--slds-c-button-color-background, var(--sds-c-button-color-background, #0174d3));
      --slds-c-button-text-color: #0174d3;
    }
    .slds-avatar_x-large {
      height: 4rem;
      width: 4rem;
    }
    .slds-vertical-tabs {
      overflow: visible;
    }
    `
  ];

  render() {
    return html`
    <div class="slds-vertical-tabs slds-m-around_large">
      <ul class="slds-vertical-tabs__nav" role="tablist" aria-orientation="vertical">
        <li class="${this.getTabLiClass(this.selectedTab, 'slds-vertical-tabs-0')}" title="Account" role="presentation">
          <a class="slds-vertical-tabs__link" href="/settings/account" @click="${this.clickLink}" role="tab" tabindex="0" aria-selected="true" aria-controls="slds-vertical-tabs-0" id="slds-vertical-tabs-0__nav">
            <span class="slds-vertical-tabs__left-icon">
              <span class="slds-icon_container" title="Identity Icon">
                <svg class="slds-icon slds-icon_small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#identity"></use>
                </svg>
              </span>
            </span>
            <span class="slds-truncate" title="Account">Account</span>
            <span class="slds-vertical-tabs__right-icon"></span>
          </a>
        </li>
        <li class="${this.getTabLiClass(this.selectedTab, 'slds-vertical-tabs-1')}" title="Password" role="presentation">
          <a class="slds-vertical-tabs__link" href="/settings/password" @click="${this.clickLink}" role="tab" tabindex="-1" aria-selected="false" aria-controls="slds-vertical-tabs-1" id="slds-vertical-tabs-1__nav">
            <span class="slds-vertical-tabs__left-icon">
              <span class="slds-icon_container" title="Lock Icon">
                <svg class="slds-icon slds-icon_small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#lock"></use>
                </svg>
              </span>
            </span>
            <span class="slds-truncate" title="Password">Password</span>
            <span class="slds-vertical-tabs__right-icon"></span>
          </a>
        </li>
        <li class="${this.getTabLiClass(this.selectedTab, 'slds-vertical-tabs-2')}" title="Profile" role="presentation">
          <a class="slds-vertical-tabs__link" href="/settings/profile" @click="${this.clickLink}" role="tab" tabindex="-1" aria-selected="false" aria-controls="slds-vertical-tabs-2" id="slds-vertical-tabs-2__nav">
            <span class="slds-vertical-tabs__left-icon">
              <span class="slds-icon_container" title="Edit Icon">
                <svg class="slds-icon slds-icon_small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#edit"></use>
                </svg>
              </span>
            </span>
            <span class="slds-truncate" title="Profile">Profile</span>
            <span class="slds-vertical-tabs__right-icon"></span>
          </a>
        </li>
        <li class="${this.getTabLiClass(this.selectedTab, 'slds-vertical-tabs-3')}" title="Content You See" role="presentation">
          <a class="slds-vertical-tabs__link" href="/settings/content" @click="${this.clickLink}" role="tab" tabindex="-1" aria-selected="false" aria-controls="slds-vertical-tabs-3" id="slds-vertical-tabs-3__nav">
            <span class="slds-vertical-tabs__left-icon">
              <span class="slds-icon_container" title="Display Text Icon">
                <svg class="slds-icon slds-icon_small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#display_text"></use>
                </svg>
              </span>
            </span>
            <span class="slds-truncate" title="Content You See">Content You See</span>
            <span class="slds-vertical-tabs__right-icon"></span>
          </a>
        </li>
        <li class="${this.getTabLiClass(this.selectedTab, 'slds-vertical-tabs-4')}" title="Privacy & Safety" role="presentation">
          <a class="slds-vertical-tabs__link" href="/settings/privacy&safety" @click="${this.clickLink}" role="tab" tabindex="-1" aria-selected="false" aria-controls="slds-vertical-tabs-4" id="slds-vertical-tabs-4__nav">
            <span class="slds-vertical-tabs__left-icon">
              <span class="slds-icon_container" title="Shield Icon">
                <svg class="slds-icon slds-icon_small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#shield"></use>
                </svg>
              </span>
            </span>
            <span class="slds-truncate" title="Privacy & Safety">Privacy & Safety</span>
            <span class="slds-vertical-tabs__right-icon"></span>
          </a>
        </li>
      </ul>
      <div class="${this.getTabClass(this.selectedTab, 'slds-vertical-tabs-0')}" id="slds-vertical-tabs-0" role="tabpanel" aria-labelledby="slds-vertical-tabs-0__nav">
        <div class="slds-text-longform">
          <h3 class="slds-text-heading_medium">Account</h3>
          <div class="slds-form">
            <div class="slds-form-element slds-form-element_stacked">
              <label class="slds-form-element__label" for="username">Username</label>
              <div class="slds-form-element__control">
                <input type="text" id="username" placeholder="Username…" class="slds-input" value="${this.user?.username}" @keyup="${this.handleValueChange}" />
              </div>
              <p>https://roflcopter.io/user/${this.user?.username}</p>
            </div>
            <div class="slds-form-element slds-form-element_stacked">
              <label class="slds-form-element__label" for="email">Email</label>
              <div class="slds-form-element__control">
                <input type="text" id="email" placeholder="Email…" class="slds-input" value="${this.user?.email}" @keyup="${this.handleValueChange}" />
              </div>
              <p>Email will not be displayed publicly</p>
            </div>
            <div class="slds-form-element slds-form-element_stacked">
              <slds-combobox id="followThreadOnReply" label="Follow Thread on Reply" .options="${this.onOffOptions}" .selected="${this.selectedFollowThreadOnReply}" @option-selected="${this.handleValueChange}"></slds-combobox>
            </div>
            <button class="slds-button slds-button_brand slds-m-top_small" @click="${this.saveChanges}" ?disabled="${this.requestPending||!this.hasNewData}">${this.requestPending ? "Saving..." : "Save Changes"}</button>
            <button class="slds-button slds-button_destructive slds-float_right slds-m-top_small">Delete Account</button>
          </div>
        </div>
      </div>
      <div class="${this.getTabClass(this.selectedTab, 'slds-vertical-tabs-1')}" id="slds-vertical-tabs-1" role="tabpanel" aria-labelledby="slds-vertical-tabs-1__nav">
        <div class="slds-text-longform">
          <h3 class="slds-text-heading_medium">Password</h3>
          <div class="slds-form">
            <div class="slds-form-element slds-form-element_stacked">
              <label class="slds-form-element__label" for="stacked-input-id-03">Old Password</label>
              <div class="slds-form-element__control">
                <input type="password" id="stacked-input-id-03" placeholder="Old Password" class="slds-input" />
              </div>
            </div>
            <div class="slds-form-element slds-form-element_stacked">
              <label class="slds-form-element__label" for="stacked-input-id-04">New Password</label>
              <div class="slds-form-element__control">
                <input type="password" id="stacked-input-id-04" placeholder="New Password" class="slds-input" />
              </div>
            </div>
            <div class="slds-form-element slds-form-element_stacked">
              <label class="slds-form-element__label" for="stacked-input-id-05">Re-Type New Password</label>
              <div class="slds-form-element__control">
                <input type="password" id="stacked-input-id-05" placeholder="Re-Type New Password" class="slds-input" />
              </div>
            </div>
            <button class="slds-button slds-button_brand slds-m-top_small" @click="${this.saveChanges}" ?disabled="${this.requestPending||Object.keys(this.pendingChanges).length === 0}">${this.requestPending ? "Saving..." : "Save Changes"}</button>
          </div>
        </div>
      </div>
      <div class="${this.getTabClass(this.selectedTab, 'slds-vertical-tabs-2')}" id="slds-vertical-tabs-2" role="tabpanel" aria-labelledby="slds-vertical-tabs-2__nav">
        <div class="slds-text-longform">
          <h3 class="slds-text-heading_medium">Profile</h3>
          <div class="slds-form">
            <div class="slds-form-element slds-form-element_stacked">
              <div class="slds-form-element__control">
                <div class="slds-grid slds-wrap">
                  <div class="slds-col slds-size_2-of-12 slds-text-align_center">
                    <input type="hidden" id="profile-picture-url" class="slds-input" />
                    <span class="slds-avatar slds-avatar_circle slds-avatar_x-large">
                      <img alt="${this.user?.display_name}" src="${this.user?.profile_pic}" title="${this.user?.display_name}" />
                    </span>
                  </div>
                  <div class="slds-col slds-size_6-of-12 slds-m-top_small">
                    <input type="file" id="profile-picture" accept="image/*" class="slds-input" @change="${this.handleProfilePictureChange}" />
                  </div>
                  <div class="slds-col slds-size_4-of-12 slds-m-top_small">
                    <div class="slds-m-left_small">
                      <button class="slds-button slds-button_neutral" style="width:100%;" @click="${this.randomizeProfilePicture}">Randomize</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="slds-form-element slds-form-element_stacked">
              <label class="slds-form-element__label" for="display-name">Display Name</label>
              <div class="slds-form-element__control">
                <input type="text" id="display_name" placeholder="Enter your display name" class="slds-input" value="${this.user?.display_name}" @keyup="${this.handleValueChange}" />
              </div>
            </div>
            <div class="slds-form-element slds-form-element_stacked">
              <div class="slds-form-element__control">
                <slds-combobox id="status" label="Status" .options="${this.statusOptions}" .selected="${this.selectedStatus}" @option-selected="${this.handleValueChange}"></slds-combobox>
              </div>
            </div>
            <div class="slds-form-element slds-form-element_stacked">
              <div class="slds-form-element__control">
                <slds-combobox id="gender" label="Gender" .options="${this.genderOptions}" .selected="${this.selectedGender}" @option-selected="${this.handleValueChange}"></slds-combobox>
              </div>
            </div>
            <div class="slds-form-element slds-form-element_stacked">
              <label class="slds-form-element__label" for="birthday">Birthday (Optional)</label>
              <div class="slds-form-element__control slds-input-has-icon slds-input-has-icon_right">
                <input type="date" id="birthday" class="slds-input" .value="${this.selectedBirthday}" @keyup="${this.handleValueChange}" />
                <button class="slds-button slds-button_icon slds-input__icon slds-input__icon_right" title="Select a date">
                  <svg class="slds-button__icon" aria-hidden="true">
                    <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#event"></use>
                  </svg>
                  <span class="slds-assistive-text">Select a date</span>
                </button>
              </div>
            </div>
            <div class="slds-form-element slds-form-element_stacked">
              <div class="slds-form-element__control">
                <slds-combobox id="homeCountry" label="Home Country" .options="${this.homeCountryOptions}" .selected="${this.selectedHomeCountry}" @option-selected="${this.handleValueChange}"></slds-combobox>
              </div>
            </div>
            <div class="slds-form-element slds-form-element_stacked">
              <label class="slds-form-element__label" for="about">About Me</label>
              <div class="slds-form-element__control">
                <textarea id="about" class="slds-input" .value="${this.about}" rows="5" @keyup="${this.handleValueChange}"></textarea>
              </div>
            </div>
            <div class="slds-form-element slds-form-element_stacked">
              <label class="slds-form-element__label" for="social-networks">Social Networks</label>
              <article class="slds-card">
                <div class="slds-card__header slds-grid">
                  <header class="slds-media slds-media_center slds-has-flexi-truncate">
                    <div class="slds-media__body slds-clearfix">
                      <h2 class="slds-card__header-title slds-float_left slds-m-bottom_none slds-m-top_xx-small">
                        <span>${this.facebookConnected ? "Facebook connected" : "Facebook not connected"}</span>
                      </h2>
                      ${this.facebookConnected ? html`<button class="slds-button slds-button_neutral slds-float_right">Disconnect</button>` : html`<button class="slds-button slds-button_brand slds-float_right">Connect now</button>`}
                    </div>
                  </header>
                </div>
              </article>
              <article class="slds-card">
                <div class="slds-card__header slds-grid">
                  <header class="slds-media slds-media_center slds-has-flexi-truncate">
                    <div class="slds-media__body slds-clearfix">
                      <h2 class="slds-card__header-title slds-float_left slds-m-bottom_none slds-m-top_xx-small">
                        <span>${this.googleConnected ? "Google connected" : "Google not connected"}</span>
                      </h2>
                      ${this.googleConnected ? html`<button class="slds-button slds-button_neutral slds-float_right">Disconnect</button>` : html`<button class="slds-button slds-button_brand slds-float_right">Connect now</button>`}
                    </div>
                  </header>
                </div>
              </article>
              <article class="slds-card">
                <div class="slds-card__header slds-grid">
                  <header class="slds-media slds-media_center slds-has-flexi-truncate">
                    <div class="slds-media__body slds-clearfix">
                      <h2 class="slds-card__header-title slds-float_left slds-m-bottom_none slds-m-top_xx-small">
                        <span>${this.appleConnected ? "Apple connected" : "Apple not connected"}</span>
                      </h2>
                      ${this.appleConnected ? html`<button class="slds-button slds-button_neutral slds-float_right">Disconnect</button>` : html`<button class="slds-button slds-button_brand slds-float_right">Connect now</button>`}
                    </div>
                  </header>
                </div>
              </article>
            </div>
            <button class="slds-button slds-button_brand slds-m-top_small" @click="${this.saveChanges}" ?disabled="${this.requestPending||Object.keys(this.pendingChanges).length === 0}">${this.requestPending ? "Saving..." : "Save Changes"}</button>
          </div>
        </div>
      </div>
      <div class="${this.getTabClass(this.selectedTab, 'slds-vertical-tabs-3')}" id="slds-vertical-tabs-3" role="tabpanel" aria-labelledby="slds-vertical-tabs-3__nav">
        <div class="slds-text-longform">
          <h3 class="slds-text-heading_medium">Content You See</h3>
          <div class="slds-form-element slds-form-element_stacked">
            <slds-combobox id="adultContent" label="Adult Content" .options="${this.onOffOptions}" .selected="${this.adultContent}" @option-selected="${this.handleValueChange}"></slds-combobox>
            <p>Enable to view adult and NSFW content in your feed and search results.</p>
          </div>
          <div class="slds-form-element slds-form-element_stacked">
            <slds-combobox id="safeBrowsing" label="Safe Browsing Mode" .options="${this.onOffOptions}" .selected="${this.safeBrowsing}" @option-selected="${this.handleValueChange}"></slds-combobox>
            <p>Adult and NSFW content will be masked.</p>
          </div>
          <div class="slds-form-element slds-form-element_stacked">
            <slds-combobox id="hideOffensiveComments" label="Hide Offensive Comments" .options="${this.onOffOptions}" .selected="${this.hideOffensiveComments}" @option-selected="${this.handleValueChange}"></slds-combobox>
            <p>Comments that are offensive will be automatically filtered from display.</p>
          </div>
          <div class="slds-form-element slds-form-element_stacked">
            <p class="slds-m-bottom_none">Blocked Titles</p>
            <button class="slds-button slds-button_outline-brand">Add Blocked Title</button>
          </div>
          <div class="slds-form-element slds-form-element_stacked">
            <p class="slds-m-bottom_none">Blocked Tags</p>
            <button class="slds-button slds-button_outline-brand">Add Blocked Tag</button>
          </div>
          <div class="slds-form-element slds-form-element_stacked">
            <p class="slds-m-bottom_none">Blocked Users</p>
            <button class="slds-button slds-button_outline-brand">Add Blocked User</button>
          </div>
          <button class="slds-button slds-button_brand slds-m-top_small" @click="${this.saveChanges}" ?disabled="${this.requestPending||Object.keys(this.pendingChanges).length === 0}">${this.requestPending ? "Saving..." : "Save Changes"}</button>
        </div>
      </div>
      <div class="${this.getTabClass(this.selectedTab, 'slds-vertical-tabs-4')}" id="slds-vertical-tabs-4" role="tabpanel" aria-labelledby="slds-vertical-tabs-4__nav">
        <div class="slds-text-longform">
          <h3 class="slds-text-heading_medium">Privacy & Safety</h3>
          <div class="slds-form-element slds-form-element_stacked">
            <label class="slds-form-element__label" for="roflcopter-device-id">Roflcopter Device ID</label>
            <div class="slds-form-element__control">
              <input type="text" id="roflcopter-device-id" class="slds-input" .value="${this.user ? this.user.user_id : ''}" disabled />
            </div>
          </div>
          <div class="slds-form-element slds-form-element_stacked">
            <label class="slds-form-element__label" for="roflcopter-data">See My Roflcopter Data</label>
            <div class="slds-form-element__control">
              <button class="slds-button slds-button_brand" id="roflcopter-data">See my data</button>
            </div>
          </div>
          <div class="slds-form-element slds-form-element_stacked">
            <div class="slds-form-element__control">
              <slds-combobox id="hideProfile" label="Hide My Profile From Search Engines" .options="${this.onOffOptions}" .selected="${this.hideProfile}" @option-selected="${this.handleValueChange}"></slds-combobox>
            </div>
          </div>
          <div class="slds-form-element slds-form-element_stacked">
            <div class="slds-form-element__control">
              <slds-combobox id="interestBasedAdvertising" label="Interest-Based Advertising" .options="${this.onOffOptions}" .selected="${this.interestBasedAdvertising}" @option-selected="${this.handleValueChange}"></slds-combobox>
            </div>
          </div>
          <button class="slds-button slds-button_brand slds-m-top_small" @click="${this.saveChanges}" ?disabled="${this.requestPending||Object.keys(this.pendingChanges).length === 0}">${this.requestPending ? "Saving..." : "Save Changes"}</button>
        </div>
      </div>
    </div>
    `
  }
}